"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNetworkConnector = exports.createWalletconnectConnector = exports.createInjectedConnector = void 0;
var web3_network_connector_1 = require("@trustpad/web3-network-connector");
var injected_connector_1 = require("@web3-react/injected-connector");
var walletconnect_connector_1 = require("@web3-react/walletconnect-connector");
var createInjectedConnector = function (chainIds) {
    return new injected_connector_1.InjectedConnector({
        supportedChainIds: chainIds,
    });
};
exports.createInjectedConnector = createInjectedConnector;
var createWalletconnectConnector = function (chainId, rpcUrl) {
    var _a;
    return new walletconnect_connector_1.WalletConnectConnector({
        chainId: chainId,
        rpc: (_a = {}, _a[chainId] = rpcUrl, _a),
        qrcode: true,
    });
};
exports.createWalletconnectConnector = createWalletconnectConnector;
var createNetworkConnector = function (chainId, rpcUrls) {
    return new web3_network_connector_1.NetworkConnector({
        defaultChainId: chainId,
        urls: rpcUrls,
    });
};
exports.createNetworkConnector = createNetworkConnector;
